
import React, {FC, useEffect} from 'react';
import {Modal} from 'react-bootstrap';
import {TimeSlot} from 'components/TimePicker/types';
import {HolderProvider, useCreateHolder} from 'components/useHolder/context';

import ModalContent from './ModalContent';
import {ModalHeader} from './ModalHeader';
import {useState} from './reducer';

type BookingProps = {
	time: TimeSlot
	onHide: () => void
}

const Booking: FC<BookingProps> = ({time, onHide}) => {
	const holder = useCreateHolder(time.id);
	const {state, dispatch} = useState(time.id, onHide);

	// Track holder state; if expired, transition step
	useEffect(() => {
		if (holder.error) {
			dispatch({type: 'ERROR', error: holder.error});
		} else if (holder.expired) {
			dispatch({type: 'EXPIRED'});
		}
	}, [holder.expired, holder.error]);

	// Render our modal but pass most rendering work
	// into <ModalContent />
	return (
		<HolderProvider holder={holder}>
			<Modal
				show scrollable
				onHide={() => dispatch({type: 'EXIT-REQUEST'})}
			>
				<Modal.Header closeButton>
					<ModalHeader step={state.step} />
				</Modal.Header>
				<Modal.Body>
					<ModalContent
						state={state}
						dispatch={dispatch}
					/>
				</Modal.Body>
			</Modal>
		</HolderProvider>
	);
};

export default Booking;
